import { Component, OnInit } from '@angular/core';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserConfirmEmail } from '@models/user-confirm-email';
import { UserDto } from '@models/user-dto';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit {

  email: string;
  token: string;
  userConfirm: UserConfirmEmail;

  constructor(private alertify: AlertifyService, private actRoute: ActivatedRoute,
     private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.email = this.actRoute.snapshot.params['email'];
    this.token = this.actRoute.snapshot.params['token'];

    // If not found in params, try query parameters (alternative method)
    if (!this.email || !this.token) {
      this.email = this.actRoute.snapshot.queryParams['email'];
      this.token = this.actRoute.snapshot.queryParams['token'];
    }
    
    this.userConfirm = {
      email : this.email,
      token : this.token
    };

    // confirm, then login
    this.confirmEmailAndLogin();
  }

  // Confirm the email and token, then login.
  confirmEmailAndLogin() {
        this.authService.confirmEmail(this.userConfirm).subscribe((response) => {
      //console.log('OK confirmEmail: ');
      this.alertify.success('Email confirmed successfully!');
      // Optionally redirect to login page or auto-login
      // this.router.navigate(['/login']);
    }, error => {
      //console.log('Error: ' + error);
      this.alertify.error('Email confirmation failed: ' + (error.error?.error || error.message || 'Unknown error'));
    }, () => { // third part , login
       // this.loginConfirmEmail();
    }
    );
  }

  loginConfirmEmail() {

    this.authService.loginConfirmEmail(this.userConfirm).subscribe(next => {
      // nothing
    }, error => {
      this.alertify.error(error); //  'Failed to login');
    }, () => {

        // login from confirmation, do nothing
      //const userDto: UserDto = JSON.parse(localStorage.getItem('user'));

      //if (!this.authService.currentUser['mustChangePassword']) {
      //  // everithign OK  -> should go to Menu 
      //  this.router.navigate(['/welcome']);
      //}
      //else {
      //  this.alertify.error("User must change password");
      //  this.router.navigate(['/chage-password', this.authService.returnCurrentUser().id]);
      //}

    }
    );
  }

}
